export var AUTH_ACTIONS = {
    SET_INVALID_DATA: 'SET_INVALID_DATA',
    SET_INVALID_EMAIL: 'SET_INVALID_EMAIL',
    SET_EXISTED_EMAIL: 'SET_EXISTED_EMAIL',
    SET_EXISTED_USERNAME: 'SET_EXISTED_USERNAME',
    SET_INVALID_CODE: 'SET_INVALID_CODE',
    SET_USER_ID: 'SET_USER_ID',
    LOGOUT: 'LOGOUT',
    SET_IS_AUTH: 'SET_IS_AUTH',
};
